import React from 'react';
import { useLocation } from 'react-router-dom'; // No need for Link here if Button handles navigation
import Button from '../components/ui/Button'; // Import your custom Button component
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';


function ServerErrorPage() {
    const location = useLocation();
    // Access the message passed via state, or use a default message
    const message = location.state?.message || 'Server error';
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    const handleRedirect = () => {
        // Navigate to login or a signup page, or dashboard if authenticated
        if (isAuthenticated) {
          navigate('/dashboard'); // or a dashboard route
        } else {
          navigate('/');
        }
      };

    return (
        <div className=" min-h-screen  flex flex-col items-center justify-center bg-base-100 text-base-content font-sans p-4 sm:p-8 ">
            <h1 className=" text-6xl sm:text-8xl font-extrabold text-primary mb-4 animate-pulse ">
                500
            </h1>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-700 mb-4 text-center">
                Oops, something wrong happened on our side
            </h2>
            <p className=" text-lg sm:text-xl text-gray-600 mb-8 max-w-xl text-center">
                {message}
            </p>
            <Button onClick={handleRedirect}> {/* Assuming your Button component takes a 'to' prop for navigation */}
                Back to EVAA
            </Button>
        </div>
    );
}

export default ServerErrorPage;